import 'angular';
import { profileComponent } from './profile.component';
import userHandler from './../../frame/header/user-handler.module';

const MODULE_NAME = 'profile';

export default angular.module(MODULE_NAME, [userHandler]).component('profileComponent', profileComponent).name;


